module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.block]
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    },
    nativeOn: {
      "click": function($event) {
        _vm.$emit('logoClicked');
      }
    }
  }, [_c('img', {
    class: [_vm.block + '-img'],
    attrs: {
      "src": _vm.logoURL,
      "alt": _vm.alt
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d8b5471e","buble":{"objectAssign":"Object.assign"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/templates/Logo.vue
// module id = 557
// module chunks = 0